export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/wooProducts/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/wooProducts',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/wooProducts',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/wooProducts/${id}`,
      data: payload,
    });
  },
});
